import { AceTag } from '../AceTag';
import { insurance } from '@axo/shared/data-access/types';
import { Tag } from '@blueprintjs/core';

export function InsuranceStatusTag({
  status,
}: {
  status: insurance.Insurance['Status'];
}) {
  if (!status) {
    return null;
  }

  switch (status) {
    case 'active':
      return (
        <Tag minimal round intent="success">
          ACTIVE
        </Tag>
      );
    case 'new':
      return (
        <Tag minimal round intent="primary">
          NEW
        </Tag>
      );
    case 'terminated':
      return (
        <Tag minimal round intent="warning">
          TERMINATED
        </Tag>
      );
    default:
      return <AceTag>{status.toUpperCase()}</AceTag>;
  }
}
